var exports = {
  "uW": "x31de4314--76081e--section",
  "j6": "x31de4314--76081e--section-heading",
  "iE": "x31de4314--76081e--wrapper",
  "Nr": "x31de4314--76081e--card",
};

module.exports = exports;
